import { Pipe, PipeTransform } from '@angular/core';
import { get, has } from 'lodash';

@Pipe({
    name: 'deepValue',
})
export class DeepValuePipe implements PipeTransform {

    transform(value: any, column: any): any {
        let res = column.value;
        if (has(column, 'key') && column.key) {
            res = get(value, column.key);
        }
        // Check for null, undefined, or empty string (after trimming)
        if (res !== null && res !== undefined) {
            if (typeof res === 'string' && res.trim() === '') {
                return '-';
            }
            return res;
        }
        return '-';
    }
}
